module.exports = __webpack_public_path__ + "img/load.5f78d609.gif";